import { AbodeAggregateMarketConditions } from '@aloft/toolkit-shared';
import {
  LabelList,
  Line,
  LineChart,
  ResponsiveContainer,
  XAxis,
  YAxis,
} from 'recharts';
import { Flex, Typography } from '@aloft/toolkit-sui';
import { computeTrend } from '../../utils/computeTrend.ts';


export const TotalComparableSales = ({
  data,
}: {
  data: AbodeAggregateMarketConditions;
}) => {
  const chartData: {
    month: string;
    totalComparableSales: number;
  }[] = data.monthlyData.filter((item) => item.total_comparable_sales !== null).map((item => ({
    month: item.month.substring(0, 7),
    totalComparableSales: item.total_comparable_sales ?? 0,
  })));
  const trendSeries = computeTrend(chartData, 'totalComparableSales');
  const maxValue = Math.max(...chartData.map(item => item.totalComparableSales));
  const trendSeriesColor =
    (trendSeries[trendSeries.length - 1] || { totalComparableSales: 0 }).totalComparableSales >= (trendSeries[0] || { totalComparableSales: 0 }).totalComparableSales
      ? '#00B050'
      : '#FF0000';

  return (
    <Flex
      flexDirection="column"
      className="commentary-chart-container"
      gap={2}
      width="100%"
      maxWidth="1400px"
    >
      <Typography variant="h3">Total # of Comparable Sales (Settled)</Typography>
      <ResponsiveContainer width="100%" height={350}>
        <LineChart
          data={chartData}
          margin={{ top: 80, right: 40, left: 0, bottom: 0 }}
        >
          <YAxis domain={[0, maxValue]} tick={false} axisLine={false} />
          <XAxis dataKey="month" interval={0} fontSize={12} tickLine={false} />
          <Line type="linear" dataKey="totalComparableSales" stroke="#3455DB" strokeWidth={2} dot={{ r: 3 }} >
            <LabelList dataKey="totalComparableSales" position="top" fontSize={12} offset={10} />
          </Line>
          <Line type="linear" data={trendSeries} dataKey="totalComparableSales" stroke={trendSeriesColor} strokeWidth={1} dot={false} strokeDasharray="5 5" />
        </LineChart>
      </ResponsiveContainer>
    </Flex >
  );
}
